import { Injectable }                       from '@angular/core';
import { MatDialog }                        from '@angular/material/dialog';
import { Store }                            from '@ngrx/store';
import { Produit }                          from '@shared/classes/produit';
import { User }           from '@shared/classes/user';
import { isProduction }   from 'src/app/shared/constants/sharedFrontConstants';
import { withLatestFrom } from 'rxjs/operators';
import { sendEmail }                        from 'src/app/shared/ngrx/store/actions/technical.actions';
import { IAppState }                        from 'src/app/shared/ngrx/store/state/app.state';
import { environment }                      from '../../../../environments/environment';
import { selectDemandeId }                  from '../../../shared/ngrx/store/selectors/bilan.selector';
import { ConfirmRappelConseillerComponent } from '../../shared/dialog/confirm-rappel-conseiller/confirm-rappel-conseiller.component';
import { RappelConseillerComponent }        from '../../shared/dialog/rappel-conseiller/rappel-conseiller.component';
import { DialogEmailComponent }             from '../steps/step-three/dialog-email/dialog-email.component';
import { DIALOG_RAPPEL_CONSEILLER }         from './self-care.constants';

@Injectable ({
               providedIn: 'root',
             })
export class SelfCareService {

  constructor (
    private _dialog: MatDialog,
    private _store: Store<IAppState>,
  ) {
  }

  public dialogConseiller (user: User, fileNamePdf: string, produits: Produit[]) {
    this._dialog.open (RappelConseillerComponent, DIALOG_RAPPEL_CONSEILLER ({
                                                                              user,
                                                                              fileNamePdf,
                                                                              produits,
                                                                            })).afterClosed ()
      .pipe (
        withLatestFrom (
          this._store.select (selectDemandeId),
        ),
      ).subscribe ({
                     next: ([m, demandeId]: [any, string]) => {
                       if (m && m.check) {
                         this._dialog.open (ConfirmRappelConseillerComponent, {
                           disableClose: true,
                           hasBackdrop:  true,
                           maxWidth:     '100vw',
                           width:        '750px',
                           height:       '220px',
                           autoFocus:    false,
                           position:     {
                             top: isProduction() ? '1900px' : null,
                           },
                           data:         {
                             demandeId,
                           },
                         }).afterClosed ();
                       }
                     },
                   });
  }

  public dialogEmail (user: User, fileNamePdf: string): void {
    this._dialog.open (DialogEmailComponent, {
      disableClose: true,
      hasBackdrop:  true,
      maxWidth:     '100vw',
      width:        '550px',
      autoFocus:    false,
      position:     {
        top: isProduction() ? '1800px' : null,
      },
      data:         {
        fileNamePdf,
        user,
      },
    }).afterClosed ().pipe ().subscribe ({
                                           next: (v) => {
                                             if(v) {
                                              this._store.dispatch (sendEmail ({ user, email: v.email, fileNamePdf }));
                                             }
                                           },
                                         });
  }


}
